<div class="form-group" [formGroup]="formGroup">
    @if (KnownKinds.includes(parameter.kind) && !parameter.options) {
        @if (
            parameter.kind === LogicStepParameterType.Primitive ||
            parameter.kind === 'Reference' ||
            parameter.kind === 'VirtualReference'
        ) {
            <clmi-workflow-wrapped-form-control
                [formControlName]="parameter.code"
                [attr.id]="parameter.code"
                [attr.required]="parameter.isRequired"
                [componentProvider]="componentProvider"
                [parameter]="parameter"
            />
        } @else if (
            parameter.kind === LogicStepParameterType.String ||
            parameter.kind === 'Identifier' ||
            parameter.kind === 'MultilineText'
        ) {
            <input
                wdxInputText
                type="text"
                class="form-control"
                [formControlName]="parameter.code"
                [attr.id]="parameter.code"
                [attr.required]="parameter.isRequired"
                [attr.maxlength]="100"
            />
        } @else {
            @switch (parameter.kind) {
                @case (LogicStepParameterType.Text) {
                    <textarea
                        wdxInputText
                        cols="30"
                        rows="4"
                        [formControlName]="parameter.code"
                        [attr.id]="parameter.code"
                        [attr.required]="parameter.isRequired"
                    ></textarea>
                }
                @case (LogicStepParameterType.Integer) {
                    <input
                        wdxInputText
                        currencyMask
                        type="text"
                        inputmode="numeric"
                        autocomplete="off"
                        class="form-control"
                        [formControlName]="parameter.code"
                        [attr.id]="parameter.code"
                        [attr.required]="parameter.isRequired"
                        [options]="integerMaskNumberConfigOverride"
                    />
                }

                @case (LogicStepParameterType.Decimal) {
                    <input
                        wdxInputText
                        currencyMask
                        type="text"
                        inputmode="decimal"
                        autocomplete="off"
                        class="form-control"
                        [formControlName]="parameter.code"
                        [attr.id]="parameter.code"
                        [attr.required]="parameter.isRequired"
                        [options]="decimalMaskNumberConfigOverride"
                    />
                }
                @case (LogicStepParameterType.Boolean) {
                    <wdx-checkbox
                        [formControlName]="parameter.code"
                        [attr.id]="parameter.code"
                        [attr.required]="parameter.isRequired"
                    ></wdx-checkbox>
                }
                @case (LogicStepParameterType.Date) {
                    <input
                        wdxInputText
                        wdxInputDate
                        type="date"
                        class="form-control"
                        [formControlName]="parameter.code"
                        [attr.id]="parameter.code"
                        [attr.required]="parameter.isRequired"
                    />
                }
                @case ('Currency') {
                    <clmi-workflow-designer-currency-control
                        [formGroup]="formGroup"
                        [controlName]="parameter.code"
                        [isRequired]="parameter.isRequired"
                    />
                }
                @case ('DateTime') {
                    <input
                        wdxInputText
                        wdxInputDate
                        type="datetime-local"
                        class="form-control"
                        [formControlName]="parameter.code"
                        [attr.id]="parameter.code"
                        [attr.required]="parameter.isRequired"
                    />
                }

                @case ('Duration') {
                    <input
                        wdxInputText
                        currencyMask
                        type="text"
                        inputmode="numeric"
                        autocomplete="off"
                        class="form-control"
                        [formControlName]="parameter.code"
                        [attr.id]="parameter.code"
                        [attr.required]="parameter.isRequired"
                        [options]="integerMaskNumberConfigOverride"
                    />
                }

                @default {
                    <p class="text-danger">
                        Unsupported kind: {{ parameter.kind }}
                    </p>
                }
            }
        }
    } @else {
        <ng-select
            [items]="
                parameter.options?.length > 0
                    ? parameter.options
                    : (options$ | ngrxPush | sortByField: 'label')
            "
            bindLabel="label"
            bindValue="value"
            [formControlName]="parameter.code"
            [id]="parameter.code"
            [multiple]="parameter.isArray"
            [searchable]="true"
            [loading]="parameter.options?.length > 0 ? false : loadingOptions"
        >
            <ng-template ng-option-tmp ng-label-tmp let-item="item">
                {{ item?.label | translateTokenisedString }}
            </ng-template>
        </ng-select>
    }
</div>
